import SuspenseSpinner from 'Utils/SuspenseSpinner';
import React from 'react';
import { Pane, Strong, Tab, Tablist } from 'evergreen-ui';
import { UTCtoTimeZone } from 'Utils/UTCConverter';
import { useSelector } from 'react-redux';
import { timeZoneSelector } from 'Features/App/appSlice';
import { useGetIncomingMessageAttachmentsQuery, useGetIncomingMessageHeadersQuery, useGetMessageAttachmentsQuery, useGetMessageHeadersQuery } from 'Services/api/messageApi';
import MessageContentRender from './Message.ContentRender';
import MessageAttachments from './Message.Attachments';
import { Attachment } from './types';
import MessageHeaders from './Message.Headers';

type MessageFileProps = {
  messageId: number
  type: string
  hasAlternativeMessage?: boolean
  useGetMessageFileById: any
}

export default function MessageFile({
  messageId,
  type,
  hasAlternativeMessage = false,
  useGetMessageFileById,
}: MessageFileProps) {
  const selectedZone = useSelector(timeZoneSelector);
  const {
    data: messageContent = {}, isFetching: isLoadingMessageContent,
  } = useGetMessageFileById(messageId, { skip: !messageId });

  const [selectedTab, setSelectedTab] = React.useState(0);
  const useGetMessageHeaders = type === 'incoming' ? useGetIncomingMessageHeadersQuery : useGetMessageHeadersQuery;
  const useGetMessageAttachments = type === 'incoming' ? useGetIncomingMessageAttachmentsQuery : useGetMessageAttachmentsQuery;

  const onSelectTab = (tab: number) => () => setSelectedTab(tab);

  const { format } = messageContent;

  const content = React.useMemo(() => {
    let stringContent = '';
    const foundedContentMessage = messageContent.content?.find((cnt: Attachment) => !cnt.attachment);
    if (foundedContentMessage) {
      stringContent = foundedContentMessage.content.data;
    }
    return stringContent;
  }, [messageContent.content]);

  if (isLoadingMessageContent) return <SuspenseSpinner />;

  return (
    <Pane display="grid" overflow="hidden" rowGap=".5rem">
      <Pane display="grid" gridTemplateRows="max-content 1fr" rowGap=".5rem">
        <Strong>{`Время сообщения: ${UTCtoTimeZone(messageContent?.dateTime, selectedZone.selectedUserTimeZone)} UTC${selectedZone.selectedUserTimeZone}`}</Strong>
        {format
          ? <Strong>{`Формат сообщения: ${format?.description || '-'}`}</Strong>
          : <Strong>{`Канал: ${messageContent?.channel?.description || '-'}`}</Strong>}
        {messageContent?.program && <Strong>{`Программа наблюдения: ${messageContent.program.name}`}</Strong>}
        <Strong>{`Статус: ${messageContent?.status?.status}`}</Strong>
        <Tablist>
          <Tab isSelected={selectedTab === 0} onSelect={onSelectTab(0)}>Содержимое сообщения</Tab>
          <Tab isSelected={selectedTab === 1} onSelect={onSelectTab(1)}>Вложения</Tab>
          <Tab isSelected={selectedTab === 2} onSelect={onSelectTab(2)}>Заголовки</Tab>
        </Tablist>
      </Pane>
      {selectedTab === 0 && <MessageContentRender fileContent={content} />}
      {selectedTab === 1 && (
        <MessageAttachments messageId={messageId} type={type} useGetMessageAttachments={useGetMessageAttachments} />
      )}
      {selectedTab === 2 && <MessageHeaders messageId={messageId} useGetMessageHeaders={useGetMessageHeaders} />}
    </Pane>
  );
}
